import i18n from '../i18n/config';

/** ISO / lokalni kodovi koji mapiraju na srpski. */
const SERBIA_COUNTRY_CODES = new Set(['rs', 'srb']);

/**
 * Jezik aplikacije na osnovu zemlje korisnika.
 * Srbija → srpski, sve ostalo → engleski.
 * @param {string|null|undefined} countryCode
 * @returns {'sr'|'en'}
 */
export function getLanguageFromCountryCode(countryCode) {
  const code = String(countryCode || '').toLowerCase().trim();
  if (SERBIA_COUNTRY_CODES.has(code)) return 'sr';
  return 'en';
}

/**
 * Postavlja i18n jezik prema countryCode (ako postoji).
 * @param {string|null|undefined} countryCode
 * @returns {'sr'|'en'|string} aktivni jezik
 */
export function applyLanguageFromCountry(countryCode) {
  if (countryCode == null || String(countryCode).trim() === '') {
    return i18n.language || 'en';
  }

  const lng = getLanguageFromCountryCode(countryCode);
  const current = String(i18n.language || '').toLowerCase();

  if (!current.startsWith(lng)) {
    i18n.changeLanguage(lng);
  }

  return lng;
}

/**
 * Izvlači countryCode iz profile / login response objekta.
 * @param {object|null|undefined} profileOrUser
 * @returns {string|null}
 */
export function getCountryCodeFromProfile(profileOrUser) {
  if (!profileOrUser) return null;
  const code =
    profileOrUser?.result?.countryCode ||
    profileOrUser?.countryCode ||
    null;
  return code ? String(code).toLowerCase() : null;
}
